import React from 'react'

interface ItemProps {
  translate: (key: string) => string
  title: string
  text: string | number | null
  className?: string
}

const Item: React.FC<ItemProps> = ({ translate, title, text, className }) => {
  return (
    <div className={className}>
      <p className="color-gray-7 mb-4">{title}</p>
      {text ? <p className="mb-0">{text}</p> : <p className="color-gray-6 mb-0">{translate('general.not-set')}</p>}
    </div>
  )
}

export default Item
